import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"menu\">\n  <path fill=\"#373630\" d=\"M5 27h80v3.53H5V27Zm0 32.941h80v3.53H5v-3.53Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol